// cards/RevenueCard.jsx
import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import RevenueTable from './RevenueTable';
import RevenueChart from './RevenueChart';
import PieChartComponent from './PieChartComponent';

const RevenueCard = ({ title, data, filters, chartType = 'bar' }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
          ${data.total.toLocaleString()}
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <RevenueTable data={data.byService} />
          </Grid>
          <Grid item xs={12} md={6}>
            {chartType === 'bar' && <RevenueChart data={data.overTime} />}
            {chartType === 'pie' && (
              <PieChartComponent 
                data={data.byService?.map(item => ({
                  name: item.service,
                  amount: item.amount
                }))} 
              />
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RevenueCard;